import { AddressDetails } from '@vend/business-components/dist/components/AddressForm/types'
import {
  getLocalizedAddressSingleLine,
  useCountryNames,
} from '@vend/business-components'
import isEmpty from 'lodash/isEmpty'

export const useLocalizedAddress = () => {
  const getCountryName = useCountryNames()

  return (addressDetails: AddressDetails | undefined): string => {
    if (isEmpty(addressDetails)) return ''

    const countryCode = addressDetails!.country_id
    return getLocalizedAddressSingleLine({
      street1: addressDetails!.address_1,
      street2: addressDetails!.address_2,
      suburb: addressDetails!.suburb,
      city: addressDetails!.city,
      postcode: addressDetails!.postcode,
      state: addressDetails!.state,
      countryCode,
      countryName: countryCode ? getCountryName(countryCode) : '',
    })
  }
}
